import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { GTMService } from '@services';
import { InstallationFeaturesStore, RichDevice } from '@store';
import {
  Feature,
  FeatureCommands,
  FeatureNames,
  FeaturePropertyKey,
  ServiceTimeBasedCommands,
  ServiceTimeBasedProperties,
} from '@vi-iot/client/index';

@Component({
  selector: 'app-system-service-interval',
  templateUrl: './system-service-interval.component.html',
  styleUrls: ['./system-service-interval.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SystemServiceIntervalComponent {
  readonly featureCommands = FeatureCommands;
  readonly featurePropertyKey = FeaturePropertyKey;

  @Input() device: RichDevice;
  @Input() heatingServiceTimeBased: Feature<ServiceTimeBasedProperties, ServiceTimeBasedCommands>;

  constructor(
    private installationFeaturesStore: InstallationFeaturesStore,
    private gtmService: GTMService
  ) {}

  resetServiceDate(): void {
    this.installationFeaturesStore.updateFeature(
      FeatureNames.serviceTimeBased,
      null,
      null,
      null,
      FeatureCommands.confirmService,
      this.device?.gatewaySerial,
      this.device?.id
    );
    this.gtmService.track('resetServiceDate');
  }

  cancelResetServiceDateConfirmation(): void {
    this.gtmService.track('onCancel', 'Reset service date confirmation', 'system');
  }
}
